import { Link } from 'react-router-dom';
import { getAllCategories } from '@/utils/course';

export default function CategoryGrid() {
  const categories = getAllCategories();

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category?cat=${cat.id}`}
          className="group flex flex-col items-center text-center gap-3 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
        >
          <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-2xl md:text-3xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
            <i className={cat.icon}></i>
          </span>
          <span className="font-heading font-bold text-sm md:text-base text-foreground-950">
            {cat.name}
          </span>
          <span className="text-[11px] md:text-xs text-foreground-500 line-clamp-2">
            {cat.subcategories.slice(0, 2).join(' · ')}
          </span>
        </Link>
      ))}
    </div>
  );
}